import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SchedulerCacheService } from '../services/scheduler-cache.service';
import { AuthService } from '../services/auth.service';
import { Permission } from '../enums/generated.enums';

@Injectable({ providedIn: 'root' })
export class SchedulerCacheInitializationGuard {
  constructor(
    private authService: AuthService,
    private schedulerCacheService: SchedulerCacheService,
  ) {}

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    const fullSchedulerCacheInitialization = this.authService.hasPermission(Permission.Orchestration) || this.authService.hasPermission(Permission.OrchestrationSettings);
    if (fullSchedulerCacheInitialization) {
      await this.schedulerCacheService.initialize();
    } else {
      await this.schedulerCacheService.initializeQueues();
    }
    return true;
  }
}
